module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/969ff69767d3ebe10f254b1cf2511d89.svg";